<template>
  <div class="overlay">
    <div class="erros-container insideErrorData">
      <div class="pt-title" v-text="title"></div>
      <div class="pt-header">
        <span v-for="(val, key) in rows[0]" v-text="val"></span>
      </div>
      <div class="pt-body">
        <div class="erros" v-for="row in rows.slice(1)">
          <span v-for="(val) in row" v-text="val"></span>
        </div>
      </div>
      <div class="pt-footer">
        <button class="button gray-button" @click="exportToExcel">
          <i class="fas fa-file-excel"></i>
          <span>{{$t('export')}}</span>
        </button>
        <div class="right-container">
          <button class="button gray-button" @click="$emit('close')">
            <i class="fas fa fa-times"></i>
            <span>{{$t('cancel')}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/application/libs/util";
import ExcelBuilder from "@/application/libs/excelBuilder";
import { t } from 'i18next';

export default {
  name: "PublishErrorsModal",
  props: ["errors"],
  data() {
    return {
      rows: [],
      title: t('publish_card_errors_title')
    };
  },
  mounted() {
    this.buildRows();
  },
  methods: {
    buildRows() {
      this.rows = [
        { DSITEM: t('CAPITAL_ITEM'), DSERRO: t('CAPITAL_ERROR') },
        ...(this.errors || [])
      ];
    },
    exportToExcel() {
      const dataRows = this.rows.slice(1);
      ExcelBuilder.fromJson(
        dataRows,
        [
          { header: t('item'), key: "DSITEM" },
          { header: t('error'), key: "DSERRO" }
        ],
        this.title,
        Util.getExcelHeaderFromFilter()
      );
    }
  }
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");
.erros-container {
  font-size: 13px;
  .sombra;
}

.gray-button {
  margin: 15px 0;
  padding: 5px;
  font-size: 1rem;
  box-shadow: none;
  background-color: #dedede;
  color: #383838;
  &:hover {
    background-color: gray;
    color: white;
  }
}
.right-container {
  float: right;
  .gray-button {
    margin: 15px 7.5px;
    &:last-of-type {
      margin-right: 0;
    }
  }
}

.overlay {
  position: fixed;
  z-index: 10;
  .full;
  background: rgba(0, 0, 0, 0.5);
}
.pt-title {
  position: relative;
  display: block;
  margin: auto;
  text-align: center;
  padding: 15px 0;
  font-size: 16px;
}
.insideErrorData {
  padding: 0 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background: white;
  width: 70%;

  max-height: 70vh;
}
.pt-header {
  height: 34px;
  background: @azul;
  color: #fff;
  display: grid;
  grid-template-columns: 1fr 2fr;
  span:first-of-type {
    padding-left: 5px;
    margin: auto 0;
  }
  span:not(:first-of-type) {
    text-align: center;
    padding-left: 5px;
    display: table;
    margin: auto;
  }
}
.pt-body {
  padding-bottom: 5px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.5);
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
    .erros {
      width: 100%;
     &:nth-of-type(2n) {
      background: rgba(196, 196, 196, 0.2);
    }
    display: grid;
    grid-template-columns: 1fr 2fr;
    span {
      margin: auto;
      padding: 5px;
      max-width: 100%;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
    }
    span:first-of-type {
      text-align: left;
      margin: auto 0;
      padding-left: 5px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
}
.pt-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.insideErrorData .pt-body {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
  &::-webkit-scrollbar {
    display: block !important;
    width: 8px !important;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
}
</style>
